import React, { ReactNode } from "react";
import { Routes, Route, Outlet } from "react-router-dom";

// Interactions Pages
import TextMessages from "pages/interactions/TextMessages";
import Emails from "pages/interactions/Emails";
import Flyers from "pages/interactions/Flyers";
import DirectMailPage from "pages/interactions/DirectMail";

import Conversations from "pages/interactions/Conversations";
import Doorknocking from "pages/interactions/Doorknocking";

import Courses from "pages/interactions/Courses";
import Events from "pages/interactions/Events";

import Files from "pages/interactions/Files";

// Layout
import Navbar_Internal from "components/PageLayouts/PageFrames/navbar_internal";
import Footer_Internal from "components/PageLayouts/PageFrames/footer_internal";
import { Box } from "@mui/material";
import Sidebar_Interactions from "components/PageLayouts/PageFrames/sidebar_interactions";

interface InternalLayoutProps {
  children: ReactNode;
}

const InternalLayout = ({ children }: InternalLayoutProps) => (
  <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
    <Navbar_Internal />
    <Box sx={{ flex: 1 }}>{children}</Box>
    <Footer_Internal />
  </Box>
);

const InteractionLayout = () => (
  <Box sx={{ display: "flex", flex: 1 }}>
    <Sidebar_Interactions />
    <Outlet />
  </Box>
);

export default function InteractionsModule() {
  return (
    <Routes>
      <Route element={<InternalLayout><Outlet /></InternalLayout>}>
        <Route element={<InteractionLayout />}>
          
          {/* Publicity submenu */}
          <Route path="/text-messages/" element={<TextMessages />} />
          <Route path="/text-messages/:id/" element={<TextMessages />} />

          <Route path="/emails/" element={<Emails />} />
          <Route path="/emails/:id/" element={<Emails />} />

          <Route path="/flyers/" element={<Flyers />} />
          <Route path="/flyers/:id/" element={<Flyers />} />

          <Route path="/direct-mail/" element={<DirectMailPage />} />
          <Route path="/direct-mail/:id/" element={<DirectMailPage />} />

          {/* Face to Face submenu */}
          <Route path="/conversations/" element={<Conversations />} />
          <Route path="/conversations/:id/" element={<Conversations />} />

          <Route path="/doorknocking/" element={<Doorknocking />} />
          <Route path="/doorknocking/:id/" element={<Doorknocking />} />

          {/* Events submenu */}
          <Route path="/courses/" element={<Courses />} />
          <Route path="/courses/:id/" element={<Courses />} />

          <Route path="/events/" element={<Events />} />
          <Route path="/events/:id/" element={<Events />} />


          {/* Additional Pages */}
          <Route path="/files/" element={<Files />} />
        </Route>
      </Route>
    </Routes>
  );
}
